import Vue from 'vue'
import Component from 'vue-class-component';
import LoadingBar from '@/components/LoadingBar.vue';
import { mapGetters } from 'vuex'
import * as types from '@/store/types';
import * as fileTypes from '@bigfile/store/types'
import * as recipientTypes from "@recipient/store/types";
import { TabItem } from '@/components';
import { FlowFile } from '@appbase/libs/flowjs';
import { FlowFileMeta } from '@appbase/components/common/FlowFileUploader/flow-file-meta';

import RecipientView from '@recipient/components/views/DeptTreeView/DeptTreeView.vue';
import BigFileView from '@bigfile/components/views/BigFileView/BigFileView.vue'
import DefaultView from '@recipient/components/views/DeptTreeView/DeptTreeView.vue';


@Component({
    components: {
        LoadingBar,
        TabItem
    },
    computed: {
        ...mapGetters({
            loading: types.PANE_LOADING,
            files: fileTypes.FILE_LIST,
            onLoadOrgTree: recipientTypes.RECIPIENT_LOADING
        }),
    },
})
export default class Master extends Vue {
    loading!: boolean;
    files!: FlowFile[]
    onLoadOrgTree!: boolean;

    metaData: FlowFileMeta | null = null;
    disableMessage: string = '';

    get bigfileProgress() {
        const { files } = this
        if (!files || files.length === 0) return 0
        return Math.floor(
            this.files.reduce((sum, x) => sum + x.percent, 0) / this.files.length
        )
    }

    get onFileUploading() {
        if(!this.files || this.files.length === 0 || this.files.every((x) => x.percent == 100)) {            
            return false
        } else {
            return true
        }        
    }

    get currentComponent() {
        const routeMap: { [key: string]: any } = {
            '/recipient': RecipientView,
            '/bigfile': BigFileView
        };
        return routeMap[this.$route.path] || DefaultView;
    }

    get loadingOrgChartMessage(): string {
        const messages: { [key: string]: string } = {
            'ko-kr': '조직도를 불러오는 중 입니다.',
            'en-us': 'Loading organization chart.',
            'zh-cn': '正在加载组织结构图。',
            'uz-uz': 'Tashkilot tuzilmasi yuklanmoqda.',
            'ru-ru': 'Загрузка организационной структуры.'
        };
        const lang = Office.context.displayLanguage.toLowerCase();
        return messages[lang] || messages['en-us'];
    }

    get uploadingFileMessage(): string {
        const messages: { [key: string]: string } = {
            'ko-kr': '파일이 업로드 중 입니다.',
            'en-us': 'File is being uploaded.',
            'zh-cn': '文件正在上传中。',
            'uz-uz': 'Fayl yuklanmoqda.',
            'ru-ru': 'Файл загружается.'
        };
        const lang = Office.context.displayLanguage.toLowerCase();
        return messages[lang] || messages['en-us'];
    }

    created() {
        const email = Office.context.mailbox.userProfile.emailAddress;
        let code = this.generateAttachmentCode(email);
        this.metaData = {
			code: code,
			codeValues: ['OfficeAddin', 'File', email, code],
			mode: 'create'
		}
    }

    generateAttachmentCode(id: string) {
		if (!id) throw new Error('ARGUMENT_NULL_EXCEPTION : id')
		const tag = 'OFFICE_ADDIN_BIGFILE'
		const uid = `UID${id.toUpperCase()}${Date.now()}`
		const code = `${tag}_${uid}`
		console.log('generateAttachmentCode', code)
		return code
	}

    onDisableClick() {
        if(this.$route.path === '/recipient') {
            (window as any).alertAsync(this.loadingOrgChartMessage);
        } else {
            (window as any).alertAsync(this.uploadingFileMessage);
        }
    }
}
